type BadgeProps = {
	variant?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl";
	rounded?: boolean;
	className?: string;
	children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

function Badge({
	children = null,
	rounded = false,
	variant = "",
	size = "md",
	className = "",
	...props
}) {
	return (
		<span
			className={`badge ${variant} ${size} ${className} ${rounded ? "rounded-full" : ""}`}
			{...props}
		>
			{children}
		</span>
	);
}

export default Badge;
